var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolCongrat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#paint0_linear_5_1447)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 19C23.8954 19 23 19.8954 23 21V24.865C23.6202 24.5372 24.292 24.2937 25 24.15V21L35 21V25C35 26.1046 35.8954 27 37 27H41V43H25V42.0189C24.3462 42.2358 23.6152 42.1789 23 41.8422V43C23 44.1046 23.8954 45 25 45H41C42.1046 45 43 44.1046 43 43V25.4142C43 24.8838 42.7893 24.3751 42.4142 24L38 19.5858C37.6249 19.2107 37.1162 19 36.5858 19H25ZM40.5858 25H37V21.4142L40.5858 25Z",
    fill: "#3DE8CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4995 33C27.3279 33 27.9995 32.3284 27.9995 31.5C27.9995 30.6716 27.3279 30 26.4995 30C25.6711 30 24.9995 30.6716 24.9995 31.5C24.9995 32.3284 25.6711 33 26.4995 33Z",
    fill: "#3DE8CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1721 37.8964L22.6163 35.395C21.6175 34.3992 20.9995 33.0218 20.9995 31.5C20.9995 28.4624 23.4619 26 26.4995 26C29.5371 26 31.9995 28.4624 31.9995 31.5C31.9995 33.0219 31.3814 34.3994 30.3825 35.3951L31.8269 37.8969C32.0128 38.2188 31.7949 38.6237 31.4239 38.646L30.2489 38.7165C30.0918 38.726 29.9484 38.8088 29.8616 38.9401L29.2131 39.9224C29.0083 40.2326 28.5487 40.2188 28.3628 39.8969L26.6885 36.9968C26.6257 36.9989 26.5627 37 26.4995 37C26.4362 37 26.3731 36.9989 26.3103 36.9968L24.6362 39.8964C24.4503 40.2183 23.9907 40.2321 23.7859 39.9219L23.1374 38.9397C23.0507 38.8083 22.9072 38.7255 22.7501 38.7161L21.5751 38.6455C21.2041 38.6233 20.9862 38.2183 21.1721 37.8964ZM26.4995 28C24.5665 28 22.9995 29.567 22.9995 31.5C22.9995 33.433 24.5665 35 26.4995 35C28.4325 35 29.9995 33.433 29.9995 31.5C29.9995 29.567 28.4325 28 26.4995 28Z",
    fill: "#3DE8CA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_1447",
    x1: -19.7148,
    y1: 46.9283,
    x2: 39.3853,
    y2: -21.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442708,
    stopColor: "#146658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29CCB1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolCongrat);
export default __webpack_public_path__ + "static/media/school-congrat.e81f5e7a2276b496c9dacef7b528d89b.svg";
export { ForwardRef as ReactComponent };